import React from 'react';
import './styles.css';

/**
 * 加載中組件
 * 
 * @param {Object} props - 組件屬性
 * @param {string} props.text - 加載文本
 * @param {string} props.size - 加載器大小 (small, medium, large)
 * @param {string} props.className - 額外的CSS類名
 * @returns {JSX.Element} 加載中組件
 */
function Loading({ text = '加載中...', size = 'medium', className = '' }) {
    return (
        <div className={`loading ${className}`}>
            <div className={`loading-spinner loading-spinner-${size}`}></div>
            {text && <div className="loading-text">{text}</div>}
        </div>
    );
}

export default Loading; 